import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInput/useMeterInput'
import PceSearchButton from '@/containers/SubscriptionFormPageNew/Components/GasMeter/PceSearch/PceSearchButton'
import getError from '@/containers/SubscriptionFormPage/getError'

const MeterInput = () => {
  const { meterIdOnBlurHandler, pceNo, isEditable, lastSentDate, meterStatus, showPceSearchButton, errors, t } =
    useMeterInput()

  return (
    <>
      <FormControl error={getError('meter_id_gas', errors)}>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pceNo}
            label={pceNo ? t('subscriptionForm:pce_module.meter_id.label') : ''}
            placeholder={t('subscriptionForm:pce_module.meter_id.placeholder')}
            status={meterStatus}
            button={<PceSearchButton hidden={!showPceSearchButton} />}
          />
        </>
      </FormControl>
    </>
  )
}

export default MeterInput
